import { DatePipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, input, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-profile-info',
  imports: [DatePipe, NgClass, NgIf],
  templateUrl: './profile-info.html',
  styleUrl: './profile-info.scss'
})
export class ProfileInfo {
  private _profilePicture: string = '';
  protected hasImageError: boolean = false;

  @Input()
  set profilePicture(value: string) {
    this._profilePicture = value || '';
    this.hasImageError = false;
  }
  get profilePicture(): string {
    return this._profilePicture;
  }

  @Input() emailVerified: boolean = false;
  @Input() createdAt: string = '';
  @Output() filtersChanged = new EventEmitter<File>();

  protected selectedImage: string | ArrayBuffer | null = null;

  onImageSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    this.filtersChanged.emit(file);
    if (file) {
      this.hasImageError = false;
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedImage = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onImageError() {
    this.hasImageError = true;
  }
}
